import { create } from 'zustand';
import { PageTitle } from '@src/api/common/PageTitleType';

interface PageTitleState {
  pageTitle: PageTitle | {};
  setPageTitle: (item: PageTitle) => void;
  getPageTitle: () => PageTitle | {};
}

export const usePageTitleStore = create<PageTitleState>((set, get) => {
  return {
    pageTitle: {},
    setPageTitle: (item: PageTitle) => {
      return set(() => {
        return { pageTitle: item };
      });
    },
    getPageTitle: () => {
      return get().pageTitle;
    },
  };
});
